import React, { useState, useEffect, useRef } from 'react';
import './Banner.css';

function Banner() {
  const [revealedWords, setRevealedWords] = useState([]);
  const [animationCycle, setAnimationCycle] = useState(0);
  const [isFadingOut, setIsFadingOut] = useState(false);

  // --- SLIDER ---
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      desktop: '/images/banner/slide1-desktop.webp',
      mobile: '/images/banner/slide1-mobile.webp',
      alt: 'slide 1'
    },
    {
      desktop: '/images/banner/slide2-desktop.webp',
      mobile: '/images/banner/slide2-mobile.webp',
      alt: 'slide 2'
    },
    {
      desktop: '/images/banner/slide3-desktop.webp',
      mobile: '/images/banner/slide3-mobile.webp',
      alt: 'slide 3'
    }
  ];
  const sliderRef = useRef(null);
  const slideCount = slides.length;

  // Auto-advance every 7s
  useEffect(() => {
    const t = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slideCount);
    }, 7000);
    return () => clearInterval(t);
  }, [slideCount]);

  // Optional: allow CSS transition cleanup for "infinite feel" (kept simple)
  // --- END SLIDER ---

  const fullText = "we make it happen.";
  const words = fullText.split(' ');
  const specialWord = "happen.";

  useEffect(() => {
    if (isFadingOut) return; // No iniciar nueva animación durante el fade out

    setRevealedWords([]);

    const revealNextWord = (index) => {
      if (index < words.length) {
        setTimeout(() => {
          setRevealedWords(prev => [...prev, index]);
          revealNextWord(index + 1);
        }, 200);
      }
    };

    revealNextWord(0);
  }, [animationCycle, words.length, isFadingOut]);

  useEffect(() => {
    const interval = setInterval(() => {
      // Primero: activar fade out
      setIsFadingOut(true);

      // Segundo: después del fade out, reiniciar la animación
      setTimeout(() => {
        setRevealedWords([]);
        setIsFadingOut(false);
        setAnimationCycle(prev => prev + 1);
      }, 800); // Duración del fade out

    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="banner">

      {/* ---- END SLIDER BLOCK ---- */}

      <div className="banner-content">
        <h1 className={`banner-title ${isFadingOut ? 'fade-out' : ''}`}>
          {words.map((word, index) => (
            <React.Fragment key={index}>
              {word === specialWord ? (
                <span
                  className={`span-special ${revealedWords.includes(index) ? 'animate-in' : 'hidden'}`}
                >
                  {word}
                </span>
              ) : (
                <span className={revealedWords.includes(index) ? 'animate-in' : 'hidden'}>
                  {word}
                </span>
              )}
              {index < words.length - 1 && ' '}
            </React.Fragment>
          ))}
        </h1>
      </div>

      {/* ---- SLIDER BLOCK (separado, no fondo) ---- */}
      <div className="simple-slider" ref={sliderRef} aria-hidden="false">
        <div
          className="simple-slider-track"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {slides.map((s, i) => (
            <div className="simple-slide" key={i}>
              <picture>
                <source media="(max-width: 768px)" srcSet={s.mobile} />
                <img src={s.desktop} alt={s.alt} className="simple-slide-img" />
              </picture>
            </div>
          ))}
        </div>

        {/* small pagination dots */}
        <div className="simple-slider-dots" aria-hidden="true">
          {slides.map((_, i) => (
            <button
              key={i}
              className={`dot ${i === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(i)}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
      </div>

    </section>
  );
}

export default Banner;
